import axiosInstance from 'common/config/axiosConfig';
import { ChangePasswordState, IProfileState } from '../slice/types';

interface ILogin {
  username: string;
  password: string;
}

const LoginAPI = {
  async handleLogin(data: ILogin) {
    const response = await axiosInstance.post('sso/security/login', data);
    return response.data;
  },

  async handleLogout() {
    const response = await axiosInstance.get('sso/security/logout');
    return response.data;
  },

  async handleRefreshToken(data: string): Promise<any> {
    const response = await axiosInstance.post('sso/security/refresh-token', {
      refreshToken: data,
    });

    return response.data;
  },

  async fetchInfoProfile(method: string, data?: IProfileState) {
    let res;
    if (method === 'GET') {
      res = await axiosInstance.get('sso/user/me');
    } else {
      await axiosInstance.put('sso/user/me/avatar', { image:data?.avatar }, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (data) {
        const { avatar, ...restData } = data;
        res = await axiosInstance.put('sso/user/me', restData);
      }
    }
    return res.data;
  },
};

export const passwordService = {
  async forgotPassword(mail: string): Promise<any> {
    const response = await axiosInstance.post('sso/security/forgot-password', {
      mail,
    });
    return response.data;
  },

  async resetPassword(data: { password: string; otp: string }): Promise<any> {
    const response = await axiosInstance.patch(
      'sso/security/reset-password',
      data
    );
    return response.data;
  },

  async handleChangePassword(data: ChangePasswordState) {
    const response = await axiosInstance.patch(
      'sso/security/change-password',
      data
    );
    return response.data;
  },
};

export default LoginAPI;
